import { v4 as uuidv4 } from "uuid";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getFontWeightOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultP1Data } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type {
  BaseBlock,
  BaseProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { defaultData as defaultH2Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H2Block/H2BlockDefaultData";
import { defaultData as defaultProductCardData } from "../ProductCard/ProductCardDefaultData";
import { defaultStyles } from "./defaultStyles";

const headerContentTemplate: BaseProp = {
  prop: "children",
  type: "children",
  value: [
    createPBlock({
      text: "Tagline",
      baseData: defaultP1Data,
      styles: {
        fontWeight: getFontWeightOptions("600"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
    createH2Block({
      text: "Products",
      baseData: defaultH2Data,
      styles: {
        fontWeight: getFontWeightOptions("700"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
    createPBlock({
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      baseData: defaultP1Data,
      styles: {
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "48",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
  ],
};

const createProductCardBlockLeft = () => ({
  id: uuidv4(),
  type: "ProductCard",
  props: {
    ...defaultProductCardData.props,
    styles: {
      prop: "styles" as const,
      type: "styles" as const,
      value: {
        ...(defaultProductCardData.props.styles?.value || {}),
        padding: getPaddingOptions({
          defaultValue: {
            paddingTop: "12",
            paddingBottom: "12",
            paddingRight: "8",
            paddingLeft: "24",
          },
        }),
      },
    },
  },
});

const createProductCardBlockCenter = () => ({
  id: uuidv4(),
  type: "ProductCard",
  props: {
    ...defaultProductCardData.props,
    styles: {
      prop: "styles" as const,
      type: "styles" as const,
      value: {
        ...(defaultProductCardData.props.styles?.value || {}),
        padding: getPaddingOptions({
          defaultValue: {
            paddingTop: "12",
            paddingBottom: "12",
            paddingRight: "16",
            paddingLeft: "16",
          },
        }),
      },
    },
  },
});

const createProductCardBlockRight = () => ({
  id: uuidv4(),
  type: "ProductCard",
  props: {
    ...defaultProductCardData.props,
    styles: {
      prop: "styles" as const,
      type: "styles" as const,
      value: {
        ...(defaultProductCardData.props.styles?.value || {}),
        padding: getPaddingOptions({
          defaultValue: {
            paddingTop: "12",
            paddingBottom: "12",
            paddingRight: "24",
            paddingLeft: "8",
          },
        }),
      },
    },
  },
});

const productCardTemplateRight: BaseProp = {
  prop: "children",
  type: "children",
  value: [createProductCardBlockRight()],
};

const productCardTemplateCenter: BaseProp = {
  prop: "children",
  type: "children",
  value: [createProductCardBlockCenter()],
};

const productCardTemplateLeft: BaseProp = {
  prop: "children",
  type: "children",
  value: [createProductCardBlockLeft()],
};

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProductShot1",
  props: {
    headerContent: headerContentTemplate,
    productCard1: productCardTemplateLeft,
    productCard2: productCardTemplateCenter,
    productCard3: productCardTemplateRight,
    productCard4: productCardTemplateLeft,
    productCard5: productCardTemplateCenter,
    productCard6: productCardTemplateRight,
    footerContent: {
      prop: "children",
      type: "children",
      value: [],
    },

    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
